import React, { useState, useEffect } from "react";

import translation from "../../../../translations/FirstOrderScreen";
import Select from "react-select";
import Api from "../../../../utils/api/Api";
import { numpadStyles } from "../../../../components/numpad/styles";

import "./CompanySelect.scss";
import { userCreateSession, userLoadData } from "../../../../utils/helpers";

export const CompanySelect = ({ onLogin }) => {
  const lang = localStorage.getItem("lang");
  const [options, setOptions] = useState(null);

  useEffect(() => {
    Api.listCompanies().then(({ data }) => {
      setOptions(
        data.data.map((company) => ({
          value: company.id,
          label: company.firstName,
        }))
      );
    });
  }, [onLogin]);

  const login = (option) => {
    Api.loginAsCompany(option.value)
      .then(async ({ data }) => {
        let token = data.token;

        await userCreateSession(token, data.refresh);
        await userLoadData(
          () => {
            localStorage.setItem("entryPoint", "re-cover");
            onLogin(token);
          },
          () => {
            if (this.button.current) {
              this.button.current.enable();
            }
          },
          true
        );
      })
      .catch(() => {
        this.props.setNotificationData({
          status: true,
          message: translation.error[this.lang],
        });
        this.button.current.enable();

        setTimeout(() => {
          this.props.setNotificationData({ status: false, message: "" });
        }, 5000);
      });
  };

  return (
    <div style={{ width: "100%" }}>
      <div style={{ marginBottom: 8 }}>
        <h1>{translation.selectCompanyTitle[lang]}</h1>
        {/* <p>{translation.selectCompanySub[lang]}</p> */}
      </div>
      {options && (
        <Select
          placeholder={translation.companySelectPlaceholder[lang]}
          options={options}
          onChange={login}
          isSearchable={false}
          className="modern-select"
          classNamePrefix="modern-select"
          styles={{
            control: (provided, state) => ({
              ...provided,
              ...numpadStyles.input,
              minHeight: "56px",
              paddingLeft: "50px",
              background:
                "#ffffff url(\"data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' fill='%23999999'/%3e%3c/svg%3e\") no-repeat 16px center",
              backgroundSize: "24px 24px",
              border: "1px solid rgba(0, 0, 0, 0.3)",
              borderRadius: "8px",
              boxShadow: "none",
              "&:hover": {
                borderColor: "rgba(0, 0, 0, 0.4)",
                boxShadow: "none",
                transform: "none",
              },
            }),
            controlFocused: (provided, state) => ({
              ...provided,
              borderColor: "#6DB395",
              boxShadow:
                "0 0 0 4px rgba(109, 179, 149, 0.15), 0 4px 16px rgba(109, 179, 149, 0.12)",
              transform: "translateY(-2px)",
            }),
            valueContainer: (provided) => ({
              ...provided,
              padding: "0px 50px 0px 16px",
              maxHeight: "100%",
              gap: "8px",
            }),
            singleValue: (provided) => ({
              ...provided,
              color: "#0B3660",
              fontSize: "16px",
              fontWeight: "500",
              fontFamily: "Inter, sans-serif",
            }),
            multiValue: (provided) => ({
              ...provided,
              backgroundColor: "rgba(109, 179, 149, 0.1)",
              borderRadius: "8px",
              border: "1px solid rgba(109, 179, 149, 0.2)",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
            }),
            multiValueLabel: (provided) => ({
              ...provided,
              color: "#1a202c",
              fontSize: "14px",
              fontWeight: "500",
              fontFamily:
                "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            }),
            multiValueRemove: (provided) => ({
              ...provided,
              color: "#6b7280",
              "&:hover": {
                backgroundColor: "rgba(239, 68, 68, 0.1)",
                color: "#dc2626",
              },
            }),
            placeholder: (provided) => ({
              ...provided,
              color: "rgba(0, 0, 0, 0.4)",
              fontSize: "16px",
              fontFamily: "Inter, sans-serif",
              fontWeight: "500",
            }),
            input: (provided) => ({
              ...provided,
              color: "#0B3660",
              fontSize: "16px",
              fontFamily: "Inter, sans-serif",
            }),
            indicatorSeparator: () => ({
              display: "none",
            }),
            dropdownIndicator: (provided, state) => ({
              ...provided,
              color: "#999999",
              padding: "8px",
              transition: "all 0.15s ease-in-out",
              transform: state.selectProps.menuIsOpen
                ? "rotate(180deg)"
                : "rotate(0deg)",
              "&:hover": {
                color: "#666666",
              },
            }),
            menu: (provided) => ({
              ...provided,
              backgroundColor: "#ffffff",
              border: "1px solid rgba(0, 0, 0, 0.3)",
              borderRadius: "8px",
              boxShadow: "0px 1px 0px 0px rgba(137, 138, 141, 1)",
              marginTop: "8px",
              overflow: "hidden",
            }),
            menuList: (provided) => ({
              ...provided,
              padding: "8px 0",
              maxHeight: "200px",
            }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isFocused ? "#EBEBEB" : "transparent",
              color: state.isFocused ? "#0B3660" : "#0B3660",
              fontSize: "16px",
              fontFamily: "Inter, sans-serif",
              fontWeight: "500",
              padding: "12px 20px",
              transition: "all 0.15s ease-in-out",
              borderLeft: "none",
              "&:active": {
                backgroundColor: "#EBEBEB",
              },
            }),
          }}
        />
      )}
    </div>
  );
};
